// extracted by mini-css-extract-plugin
module.exports = {"alert":"style_alert__l0NFz","alert-text":"style_alert-text__xsYOd"};